export const percentFormatOneDigit = percent => percent ? new Intl.NumberFormat('es-ES', {
    maximumFractionDigits: 1
}).format(percent): '0';